const state = {
  useTitle: '首页',
};

// getters
const getters = {};

// mutations
const mutations = {
  change_title(state, newData) {
    console.log(999,state)
    state.useTitle = newData;
  },
};

// actions
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
